import { Navigate, Route, Routes } from "react-router";
import { Auth } from "./components/auth";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AccountPage } from "./pages/AccountPage/";
import { DashboardPage } from "./pages/DashboardPage";
import { ProfilePage } from "./pages/ProfilePage";
import { ROUTES } from "./shared/constants/router";

function App() {
	return (
		<Routes>
			<Route
				path={ROUTES.ROOT}
				element={<Navigate to={ROUTES.DASHBOARD} replace />}
			/>
			<Route path={ROUTES.AUTH} element={<Auth />} />
			<Route
				path={ROUTES.ACCOUNT}
				element={
					<ProtectedRoute>
						<AccountPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path={ROUTES.PROFILE}
				element={
					<ProtectedRoute>
						<ProfilePage />
					</ProtectedRoute>
				}
			/>
			<Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
			<Route path={ROUTES.NOT_FOUND} element={<Auth />} />
		</Routes>
	);
}

export default App;
